import { useEffect, useState } from 'react';
import { airTracker } from '@/utils/airTracker';
import { Customer, getCustomer } from '@/api/customer';
import { COMPONENT_NAME } from '@/pages/Main';

export const useGetCustomer = (
  enabledPa: boolean,
  clientSecret?: string,
  customerId?: string
): { customer: Customer | undefined; loading: boolean } => {
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState<Customer>();

  useEffect(() => {
    if (enabledPa && clientSecret && customerId) {
      setLoading(true);
      const fetchCustomer = async (): Promise<void> => {
        try {
          const data = await getCustomer(clientSecret, customerId);

          setCustomer(data);
          airTracker.info('fetchCustomerSuccess', { component: COMPONENT_NAME, customerId });
          setLoading(false);
        } catch (error) {
          airTracker.error('apiError', { api: 'getCustomer', error });
          setLoading(false);
        }
      };
      fetchCustomer();
    } else {
      setLoading(false);
    }
  }, [clientSecret, enabledPa, customerId]);

  return { customer, loading };
};
